import React from 'react';
import DefaultSimManuelRecipient from '../components/ManulRecipient/DefaultSimManuelRecipient';
import { customer_id } from '../utils/DictionaryManagementUtils';

//= ========================================================================

const Sim_F07_SplitPaymentToCustomerIDManually = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <DefaultSimManuelRecipient
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
    manualName={customer_id}
  />
);

export default Sim_F07_SplitPaymentToCustomerIDManually;
